//© 2025 Kaitlyn Troxell
import { useState, useEffect } from 'react';
import { collection, getDocs, doc, updateDoc, query, orderBy, where } from 'firebase/firestore';
import { db } from '../firebase';

function useUsers(user) {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      if (!user) return;
      const usersQuery = query(
        collection(db, 'users'),
        where('active', '==', true),
        orderBy('createdAt', 'asc')
      );
      
      const querySnapshot = await getDocs(usersQuery);
      const usersList = [];
      querySnapshot.forEach(doc => {
        usersList.push({ id: doc.id, ...doc.data() });
      });
      setUsers(usersList);
    };
    
    fetchUsers();
  }, [user]);

  const toggleUserStatus = async (userId, isActive) => {
    await updateDoc(doc(db, 'users', userId), { active: isActive });
    setUsers(prev => prev.map(u => {
      return u.id === userId ? { ...u, active: isActive } : u;
    }));
  };

  return { users, toggleUserStatus };
}

export default useUsers;